import React, { useEffect, useState } from 'react';
import styles from './Topup.module.css';
import {
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerTrigger
} from '../ui/drawer';
import { BiRupee } from "react-icons/bi";
import { IoCloseSharp } from "react-icons/io5";
import { FaWallet } from "react-icons/fa";
// import GameIconButton from '../GameIconButton/GameIconButton';
import { GameIconButton } from '@themed-components';
import { Slider } from "../ui/slider";
import { usePlayerBalance } from "@/src/hooks/data/useLobby";
import { 
  useGameDefinition,
  usePlayerData,
  usePlayerSeat as useGamePlayerSeat
} from "@/src/hooks/data/useGameTable";
import useGameSocket from "@/src/hooks/utils/useGameSocket";
import { RUPEE_SYMBOL } from "@/Poker/data/Constants";
import { parseDecimalValuesOfNumber } from '@/Common/utils/GameUtils';
import useGameConnection from '@/src/hooks/data/useGameConnection';
import { showToast } from '@/Poker/utils/toastUtils';
import { TOAST_INFO } from '@/Poker/data/Constants';

export default function Topup({ tempTableId }) {
    const { totalBalance } = usePlayerBalance();
    const gameDefinition = useGameDefinition(tempTableId);
    const { smallBlind, bigBlind, maxbuyInAmount } = gameDefinition || {};
    const playerData = usePlayerData(tempTableId);
    const playerSeat = useGamePlayerSeat(tempTableId);
    const { connected } = useGameConnection(tempTableId);
    const { sendTopUpProtocol } = useGameSocket(tempTableId);

    const currentUserData = playerData?.find(player => player.position === playerSeat);
    const atTableAmount = currentUserData?.atTableAmount || 0;

    const minTopupAmount = atTableAmount + bigBlind;
    const maxTopupAmount = Math.min(maxbuyInAmount, totalBalance);

    const [topupAmount, setTopupAmount] = useState(minTopupAmount);


    useEffect(() => {
        setTopupAmount(minTopupAmount);
    }, [minTopupAmount]);

    const handleTopupButton = () => {
        if (connected) {
            sendTopUpProtocol(parseDecimalValuesOfNumber(topupAmount, 2));
        } else {
            showToast(TOAST_INFO, 'Top Up', 'Please reconnect to the table to top up')
        }
    };

    return (
        <Drawer>
            <DrawerTrigger asChild>
                <GameIconButton>
                    <BiRupee />
                </GameIconButton>
            </DrawerTrigger>

            <DrawerContent side="bottom" className={styles.container}>
                {/* Header with centered title and close button */}
                <div className={styles.header}>
                    <div className={styles.headerSpacer}></div>
                    <h2 className={styles.title}>Top Up</h2>
                    <DrawerClose className={styles.closeButton}>
                        <IoCloseSharp color={'var(--color-primary)'} className={styles.closeIcon} />
                    </DrawerClose>
                </div>

                <div className={styles.topupContent}>
                    {/* Details section */}
                    <div className={styles.detailsSection}>
                        <div className={styles.detailRow}>
                            <div className={styles.leftContent}>
                                <span className={styles.detailLabel}>Blinds:</span>
                                <span className={styles.detailValue}>{smallBlind}/{bigBlind}</span>
                            </div>
                            <div className={styles.rightContent}>
                                <span className={styles.walletHeader}>Wallet Balance</span>
                            </div>
                        </div>

                        <div className={styles.detailRow}>
                            <div className={styles.leftContent}>
                                <span className={styles.detailLabel}>Max Buy In:</span>
                                <span className={styles.detailValue}>{RUPEE_SYMBOL + maxbuyInAmount}</span>
                            </div>
                            <div className={styles.rightContent}>
                                <div className={styles.walletBalance}>
                                    <FaWallet className={styles.walletIcon} />
                                    <span className={styles.balanceAmount}>{RUPEE_SYMBOL + totalBalance}</span>
                                </div>
                            </div>
                        </div>

                        {/* <div className={styles.detailRow}>
                            <div className={styles.leftContent}>
                                <span className={styles.detailLabel}>Chips Stack:</span>
                                <span className={styles.detailValue}>{RUPEE_SYMBOL + atTableAmount}</span>
                            </div>
                        </div> */}
                    </div>

                    <div className={styles.topupBottomRow}>
                        {/* Top Up Amount */}
                        <div className={styles.detailRow}>
                            <div className={styles.leftContent}>
                                <span className={styles.topupAmountLabel}>Top Up To:</span>
                            </div>
                            <div className={styles.topupAmountContainer}>
                                <span className={styles.topupAmountValue}>{RUPEE_SYMBOL + parseDecimalValuesOfNumber(topupAmount, 2)}</span>
                            </div>
                        </div>

                        {/* Slider */}
                        <div className={styles.sliderContainer}>
                            <Slider
                                value={[parseDecimalValuesOfNumber(topupAmount, 2)]}
                                onValueChange={(value) => setTopupAmount(value[0])}
                                min={minTopupAmount}
                                max={maxTopupAmount}
                            />
                            <div className={styles.sliderLabelContainer}>
                                <span className={styles.sliderLabel}>Min. {RUPEE_SYMBOL + parseDecimalValuesOfNumber(minTopupAmount, 2)}</span>
                                <span className={styles.sliderLabel}>Max. {RUPEE_SYMBOL + parseDecimalValuesOfNumber(maxTopupAmount, 2)}</span>
                            </div>
                        </div>
                    </div>

                    {/* Top Up Button */}
                    <div className={styles.buttonContainer}>
                        <DrawerClose asChild>
                            <button className={styles.topupButton} onClick={handleTopupButton}>
                                Top Up
                            </button>
                        </DrawerClose>
                    </div>
                </div>
            </DrawerContent>
        </Drawer>
    );
}